import { t } from '@lingui/macro';
import i18n from 'config/i18n';
import Config from 'config';
import { GET_CONFIGURATIONS, SET_TITLE, SET_VALUE, REMOVE_MESSAGE, SET_MESSAGE, GET_MAX_SIZE } from './actions';

const initialState = {
  /**
   * Holds the app configurations
   */
  config: {
    IS_NATIVE: !!window.isNativeApp,
    APP_TITLE: '',
    APP_DOWNLOAD_SONG_FILE: false,
    APP_SIGNUPS_ENABLED: 'Enabled',
    APP_FORCE_LOGIN: 'Disabled',
    APP_DOWNLOAD_SONG_FILE: 'Disabled',
    APP_GA_ENABLED: false,
    APP_GA_ID: '',
    APP_FACEBOOK_ENABLED: false,
    APP_FACEBOOK_APP_ID: '',
    APP_LEGAL_TERMS: '',
    APP_LEGAL_PRIVACY: '',
    APP_LANGUAGE: 'en',
    APP_MENU: [
      { id: 'discover', visible: true, label: 'Discover', link: '/app/discover', editable: false },
      { id: 'browse', visible: true, label: 'Browse', link: '/app/browse', editable: false },
      { id: 'news', visible: true, label: 'News', link: '/app/blog', editable: false },
      { id: 'artists', visible: true, label: 'Artists', link: '/app/artists', editable: false },
    ],
    APP_PAYWALL_THANKS_TITLE: i18n._(t`Welcome!`),
    APP_PAYWALL_THANKS_DESCRIPTION: i18n._(t`Thank you for signing up! You now have access to all premium features.`),
    ...Config.app,
    APP_CURRENT_THEME: Config.app.APP_CURRENT_THEME || 'dark',
    APP_CUSTOM_THEME_STYLES: {
      custom: '',
      title: { bg: '', iconColor: '', color: '' },
      mainMenu: { bg1: '', bg2: '', titles: '', color: '', selected: '', border: '' },
      mainToolbar: { bg: '', color: '', iconColor: '' },
      player: { bg: '', color: '', buttonsOverBg: '', progress: '', loaded: '', total: '' },
      common: { mainBg: '', containersBg: '', containersBorderColor: '', sidebarBg: '', color: '', secondaryColor: '', tertiaryColor: '', linkColor: '', linkHoverColor: '' },
      forms: { bg: '', bgOver: '', border: '', color: '', placeholderColor: '' },
      buttons: { primaryBg: '', primaryOverBg: '', primaryColor: '', primaryBorderColor: '', secondaryBg: '', secondaryOverBg: '', secondaryColor: '', secondaryBorderColor: '', tertiaryBg: '', tertiaryOverBg: '', tertiaryColor: '', tertiaryBorderColor: '' },
      tags: { bg: '', bgOver: '', color: '', colorOver: '' },
    },
  },

  /**
   * The selected language for the UI
   */
  language: Config.app.APP_LANGUAGE,

  /**
   * The title for the current page,
   * we need to share accross different components
   */
  title: '',

  /**
   * Messages to show in the global toast
   * {
   *  id: 123,
   *  message: `<Trans>Something to inform</Trans>`,
   *  type: 'success',
   * }
   */
  messages: [],

  /**
   * The max file size the server allows for uploads
   */
  uploads: {
    bytes: 0,
    kilobytes: 0,
    megabytes: 0,
  },

  /**
   * A map to track all the request calls.
   *  
   *  `true`  = request is loading data from the server
   *  `false` = requests is loaded, either with success or error
   */
  requests: {},
};

export default function reducer(ste = initialState, action) {
  let state = ste;

  if (action.requestId) {
    state = {
      ...ste,
      requests: {
        ...ste.requests,
      },
    };

    if (state.requests[action.requestId]) {
      delete state.requests[action.requestId];
    } else {
      state.requests[action.requestId] = true;
    }
  }

  switch (action.type) {
    case GET_CONFIGURATIONS.SUCCESS:
      return {
        ...state,
        config: {
          ...state.config,
          ...action.payload.configurations.reduce((result, current) => {
            result[current.key] = current.value;
            if (current.key === 'APP_CUSTOM_THEME_STYLES') {
              result[current.key] = {
                ...state.config.APP_CUSTOM_THEME_STYLES,
                ...JSON.parse(current.value),
              };
            }
            if (['APP_MENU', 'APP_FORUM_TOPICS'].includes(current.key)) {
              result[current.key] = JSON.parse(current.value);
            }
            return result;
          }, {}),
        },
      };
    case GET_MAX_SIZE.SUCCESS:
      return {
        ...state,
        uploads: {
          bytes: action.payload.data.size,
          kilobytes: action.payload.data.size / 1024,
          megabytes: action.payload.data.size / 1024 / 1024,
        },
      };
    case SET_TITLE:
      return {
        ...state,
        title: action.payload.title,
      };
    case REMOVE_MESSAGE:
      return {
        ...state,
        messages: state.messages.filter(msg => msg.id !== action.payload.config.id),
      };
    case SET_MESSAGE:
      return {
        ...state,
        messages: [...state.messages, action.payload.config],
      };
    case SET_VALUE: {
      const { name, value } = action.payload;
      return {
        ...state,
        config: {
          ...state.config,
          [name]: value,
          APP_GA_ENABLED: name === 'APP_GA_ID' ? value !== '' : state.config.APP_GA_ENABLED,
          APP_FACEBOOK_ENABLED: name === 'APP_FACEBOOK_APP_ID' ? value !== '' : state.config.APP_FACEBOOK_ENABLED,
        },
      };
    }
    default:
      return state;
  }
}
